import React from 'react';
import {Entry, EntryStage, Onlive} from '@2023-contest-web/components/src/types';
import {
    Entries,
} from '@2023-contest-web/components/src/components/Entries';
import {
    EntryCard,
} from '@2023-contest-web/components/src/components/EntryCard';
import {
    EntryStageBreadCrumb,
} from '@2023-contest-web/components/src/components/BreadCrumb';
import {
    Footer,
} from '@2023-contest-web/components/src/components/Footer';
import {
    Header,
} from '@2023-contest-web/components/src/components/Header';
import {
    SectionTitle,
} from '@2023-contest-web/components/src/components/SectionTitle';
import classNames from 'classnames';
import { useResource } from 'retil';
import {entryList, onliveList} from '../../resources';

export interface EntryListAppProps {
    title: string;
    subtitle: string;
    stage: EntryStage;
}

export function EntryListApp({ title, subtitle, stage, }: EntryListAppProps) {
    const [state] = useResource(entryList);
    const [onlives] = useResource(onliveList);
    return (
        <main className="EntryListApp">
            <Header />
            <section className="section" style={{ minHeight: '100vh' }}>
                <div className="container">
                    <SectionTitle className="title" style={{ marginBottom: 60 }} title={title} subtitle={subtitle} />
                    <EntryStageBreadCrumb stage={stage} type="misscircle" />
                    <div className="columns is-multiline is-mobile is-margin-bottom-3">
                        <Entries state={state}>
                            {(list: Entry[]) =>
                                filter(list, stage).map((item: Entry) => (
                                    <div className={classNames('column is-3-desktop is-4-tablet is-6-mobile')} key={item.entry_id}>
                                        <EntryCard onlive={isOnlive(item)} entry={item} href={`/entry/${item.entry_id}`} />
                                    </div>
                                ))
                            }
                        </Entries>
                    </div>
                </div>
            </section>
            <Footer href="mailto:circle@age.co.jp" />
        </main>
    );

    function filter(list: Entry[], stage: EntryStage) {
        switch (stage) {
            case 3:
                return list.filter((entry) => entry.stage >= 3);
            case 4:
                return list.filter((entry) => entry.stage >= 4);
            case 5:
                return list.filter((entry) => entry.stage >= 5);
            case 6:
                return list.filter((entry) => entry.stage >= 6);
            case 7:
                return list.filter((entry) => entry.stage >= 7);
            default:
                return [];
        }
    }
    function isOnlive(entry: Entry) {
        const [onlive] = onlives.data.filter((onlive: Onlive) => onlive.entry_id == entry.entry_id);
        return !!onlive;
    }
}